import { localLogger } from "./localLogger";

export async function log(message: any) {
  try {
    console.log("LOGGING response", message);
    await localLogger.log(`Notification LOGGER: ${message}`);
  } catch (e) {
    console.error("CANT LOG ERROR", e);
  }
}
